











































































import { PropType } from 'vue';
import { InvoiceStateEnum } from '@/models';
import authMixin from '@/mixins/auth';
import mixins from '@/utils/mixins';

export default mixins(authMixin).extend({
  name: 'InvoiceOptionsButton',
  props: {
    state: Number as PropType<InvoiceStateEnum>
  },
  data() {
    return {
      InvoiceStateEnum
    };
  },
  computed: {
    canCancel(): boolean {
      return (
        this.state === InvoiceStateEnum.Sent ||
        this.state === InvoiceStateEnum.Approved ||
        this.state === InvoiceStateEnum.Draft
      );
    }
  }
});
